import http from 'plugins/axios';

export default {
  //获取广告页配置信息
  getStartPageList(data){
    return http.post({
      url: '/la/admin/app/page/conf/list',
      data:{confType:'2'},
      dataType: 'form'
    });
  },
  //添加配置
  getStartPageAdd(data){
    return http.post({
      url:'/la/admin/app/page/conf/adv/add',
      data
    })
  },
  //更新配置
  getStartPageUpdate(data){
    return http.post({
      url:'/la/admin/app/page/conf/adv/update',
      data
    })
  },
  //是否显示登陆开关
  isShowLogin({id,type}){
    return http.post({
      url:`/la/admin/app/page/conf/loginSwitch?id=${id}&type=${type}`,
      // data:{
      //   id,type
      // }
    })
  },
  //是否开启会生成配置
  isOpenSwitch({confType,id,type}){
    return http.post({
      url:`/la/admin/app/page/conf/openSwitch?id=${id}&type=${type}&confType=${confType}`
    })
  },
  //删除配置
  delOne(id){
    return http.get({
      url:`/la/admin/app/page/conf/delete/${id}`
    })
  },


  // getBannerList(data) {
  //   return http.post({
  //     url: '/la/admin/banner/list',
  //     data,
  //     dataType: 'form'
  //   });
  // },
  getBannerDetail(id) {
    return http.get({
      url: `/la/admin/banner/detail/${id}`
    });
  },
  createBanner(data) {
    return http.post({
      url: '/la/admin/banner/add',
      data,
      dataType: 'form'
    });
  },
  updateBanner(data) {
    return http.post({
      url: '/la/admin/banner/update',
      data,
      dataType: 'form'
    });
  },
  removeBanner(id) {
    return http.get({
      url: `/la/admin/banner/delete/${id}`
    });
  },
  updateSort(data) {
    return http.post({
      url: '/la/admin/banner/sort',
      data,
      dataType: 'form'
    });
  },
  getbannerType(data) {
    return http.get({
      url: '/la/admin/banner/bannerType',
      data
    });
  }
};
